import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import LoadingButtons from '@app/activity/BlackFridayCheckIn/components/LoadingButtons';
import SignIn from '@app/activity/BlackFridayCheckIn/components/SignIn';
import { useBlackFridayCheckInProps } from '@base/activity/blackFridayCheckIn/useBlackFridayCheckIn';
import Image from '@base/lib/ThemeImage';
import HelpPopup from '@base/lib/HelpPopup';
import Iconfont from '@base/lib/Iconfont';
import BlackFridayCheckInTips from '@base/activity/blackFridayCheckIn/Tips';

type IProps = {
    checkIn: useBlackFridayCheckInProps
}

const SignInComponent: React.FC<IProps> = (props) => {
    const { checkIn } = props

    const { currentStep, isLogin } = checkIn

    // 签到前 start loading 按钮 阶段
    const isBeforeCheckStage = ['not-started', 'start', 'loading'].includes(currentStep)
    // 签到中 阶段
    const isCheckStage = ['pre-check', 'checked'].includes(currentStep)

    return (
        <div className={styles['bf-sign-in-wrap']}>

            <div className={styles['title-wrap']}>
                <HelpPopup
                    width={600}
                    title={'Rules of Engagement'}
                    trigger={<Iconfont className={cn('icon-help', styles['tips'])}/>}
                    content={<BlackFridayCheckInTips />}
                />

                {isBeforeCheckStage && (
                    <p className={styles['text']}>CLICK THE BUTTON TO START YOUR</p>
                )}

                <div className={cn(styles['img-title'], 'text-center')}>
                    <div className={styles['img']}>
                        <Image
                            src={'asset/width-48/picture/e72411acc10a8a8e70540a3d849f8722.png'}
                            background={false}
                            height={20}
                            width={24}
                        />
                    </div>
                    <span className={cn(styles['text'])}>LOVE WHAT YOU GROW</span>
                    <div className={styles['img']}>
                        <Image
                            src={'asset/width-48/picture/425d6b6447292afaee625b05fcb949ae.png'}
                            background={false}
                            height={20}
                            width={24}
                        />
                    </div>
                </div>

                <p className={styles['text']}>PLANTING JOURNEY</p>

                {isCheckStage && (
                    <div className={'text-center'}>
                        <div className={styles.date}>
                            NOV 10 - NOV 29
                        </div>
                    </div>
                )}

            </div>

            {isBeforeCheckStage && <LoadingButtons checkIn={checkIn}/>}

            {isCheckStage && <SignIn checkIn={checkIn}/>}

        </div>
    );
};

export default SignInComponent